export class VortexError extends Error {
    constructor(originalError) {
        var _a;
        super((_a = originalError.message) !== null && _a !== void 0 ? _a : 'Unknown error from Vortex');
        Object.defineProperty(this, "originalError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.setPrototypeOf(this, VortexError.prototype);
        this.originalError = originalError;
    }
}
//# sourceMappingURL=VortexError.js.map